import script from "./NovoProjeto.vue?vue&type=script&lang=ts&setup=true"
export * from "./NovoProjeto.vue?vue&type=script&lang=ts&setup=true"

import "./NovoProjeto.vue?vue&type=style&index=0&id=32c875f1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c875f1"]])

export default __exports__